import { JobBasedDataMonitor } from './JobBasedDataMonitor';

type JobBasedExposureTileProps = {
  jobId: number;
  exposureName: string;
};

export const JobBasedExposureTile = ({
  jobId,
  exposureName,
}: JobBasedExposureTileProps) => {
  return <JobBasedDataMonitor jobId={jobId} exposureName={exposureName} />;
};
